var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import BrowserSession from '../../common/src/BrowserSession';
import { Execute } from '../../common/src/messages/Blade';
import BaseRequest from '../../common/src/messages/verto/BaseRequest';
import Call from '../../common/src/webrtc/Call';
export default class SignalWire extends BrowserSession {
  execute(message) {
    let msg = message;

    if (message instanceof BaseRequest) {
      const params = {
        message: message.request
      };

      if (message.targetNodeId) {
        params.node_id = message.targetNodeId;
      }

      msg = new Execute({
        protocol: this.relayProtocol,
        method: 'message',
        params
      });
    }

    return super.execute(msg);
  }

  newCall(options) {
    return __awaiter(this, void 0, void 0, function* () {
      const {
        destinationNumber = null
      } = options;

      if (!destinationNumber) {
        throw new TypeError('destinationNumber is required');
      }

      const call = new Call(this, options);
      call.invite();
      return call;
    });
  }

}